"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class TaxonomyController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            import: 'v1/taxonomy/import-zip',
            activate: 'v1/taxonomy/:taxonomyId/activate',
            deactivate: 'v1/taxonomy/:taxonomyId/deactivate',
            delete: 'v1/taxonomy/:objectId',
        };
    }
    create({}) {
        throw new Error("Can't create taxonomies!");
    }
    edit({}) {
        throw new Error("Can't edit taxonomies!");
    }
    import(formData) {
        return this.manager.post({ url: this.endpoints.import }, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    activate(taxonomyId) {
        return this.manager.put({ url: this.endpoints.activate, params: { taxonomyId } });
    }
    deactivate(taxonomyId) {
        return this.manager.put({ url: this.endpoints.deactivate, params: { taxonomyId } });
    }
}
exports.default = TaxonomyController;
